// src/i18n.js
import { createI18n } from "vue-i18n";
import khmMessage from "@/lang/khm.json";
import enMessage from "@/lang/en.json";

const messages = {
    khm: khmMessage,
    en: enMessage,
};

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'en', // set locale
    fallbackLocale: 'khm', // set fallback locale
    messages, // set locale messages
});

export default i18n;